import { render, staticRenderFns } from "./Achats.vue?vue&type=template&id=52c83bfc"
import script from "./Achats.vue?vue&type=script&lang=js"
export * from "./Achats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports